import { createTheme, PaletteColor, PaletteColorOptions } from "@mui/material";
import {
  amber,
  blue,
  cyan,
  deepOrange,
  green,
  indigo,
  lightBlue,
  lightGreen,
  pink,
  purple,
  red,
  teal,
} from "@mui/material/colors";
// import { ExpenseCategory, IncomeCategory } from "../types";

export const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans JP, Roboto, Arial, sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  palette: {
    // 上半身
    upperBody: {
      main: amber[500],
      light: amber[100],
      dark: amber[700],
    },
    // 下半身
    lowerBody: {
      main: teal[500],
      light: teal[100],
      dark: teal[700],
    },
    // 有酸素運動
    cardio: {
      main: indigo[500],
      light: indigo[100],
      dark: indigo[700],
    },
    // 収入
    incomeColor: {
      main: blue[500],
      light: blue[100],
      dark: blue[700],
    },
    // 支出
    expenseColor: {
      main: red[500],
      light: red[100],
      dark: red[700],
    },
    // 残高
    balanceColor: {
      main: green[500],
      light: green[100],
      dark: green[700],
    },

    incomeCategoryColor: {
      給与: lightBlue[600],
      副収入: cyan[200],
      お小遣い: lightGreen["A700"],
    },
    expenseCategoryColor: {
      食費: deepOrange[500],
      日用品: lightGreen[500],
      住居費: amber[500],
      交際費: pink[300],
      娯楽: cyan[200],
      交通費: purple[400],
    },
    upperBodyExerciseColor: {
      サイドレイズ: deepOrange[300],
      アームカール: lightGreen[300],
      ベンチプレス: amber[300],
      チンニング: pink[300],
      ベントオーバーロウ: cyan[300],
    },
    lowerBodyExerciseColor: {
      スクワット: deepOrange[300],
      デッドリフト: lightGreen[300],
    },
    cardioExerciseColor: {
      スイミング: lightGreen[300],
      ランニング: cyan[200],
    },
  },
});
